<template>
  <div class="upload-img">
    <div class="content-wrapper">
      <div class="upload-img-content">
        <p class="content-title">{{date.title}}</p>
        <p class="content-subtitle">{{date.sub_title}}</p>
        <p class="content-p" v-for="(t,idx) in date.desc" :key="idx" v-html="t"></p>
      </div>
      <div class="select-wraper">
        <div class="select" @click="showPicker">
          {{date_config.text||date.option_title}}
          <span class="info-arrow"></span>
        </div>
        <p
          :class="{'status-tip':1}"
          v-show="date_config.tip"
          v-html="date_config.tip"
        >{{date_config.tip}}</p>
      </div>
    </div>
    <div class="content-wraper" v-show="date.value&&date_config.pic_desc">
      <div class="upload-img-content">
        <p class="content-subtitle">{{photo_config.title}}</p>
        <p class="content-p" v-for="(t,idx) in photo_config.content" :key="idx" v-html="t"></p>
      </div>
      <div class="photos" v-show="!date_config.is_not_need_upload">
        <div v-for="(p, i) in pic_field" :key="i">
          <p>{{p.title}}</p>
          <div class="img-wraper">
            <div v-for="(v, index) in p.show_value" :key="index" class="imgs">
              <img-v3 :src="v" />
              <div v-if="!hideBottom" class="close" @click="removeImg(p,index)">x</div>
            </div>
            <div class="add-pic" v-show="p.value.length<p.max_pic_num && !hideBottom">
              <template v-if="upload_exam_pic_url">
                <img-v3 :src="upload_exam_pic_url" />
                <img-v3 class="upload-icon" :src="require('../../images/icon_camera.png')" alt="" />
              </template>
              <template v-else>
                +
              </template>
              <template v-if="inApp">
                <input type="button" @click="selectImg(p)" />
              </template>
              <template v-else>
                <input v-if="formItem.limit_status" id="photo" type="file" accept="image/*" capture="camera">
                <input v-else class="input_photo" type="file" accept="image/*" @click="outFileChoose(p)" />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="upload-input-wrapper" v-if="!hideBottom">
      <p class="declare" @click="declareClick" v-if="declare.desc_title">
        <i :class="{active:aggre}"></i>
        {{declare.desc_title}}
      </p>
      <div
        :class="['multi-link-upload', 'au-multi-submit', `${country}-multi-link-upload`, {'multi-link-upload-active': valid}, {'au-multi-submit-active': valid}]"
        @click="submitImg"
      >{{$t('img.submit_btn_txt')}}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { imgCompress } from "../../tools/utils";
import { post } from "../../tools/request";
import { showLoadingToast, showAlertDialog } from "../../tools/Tip";

const AUDIT_STATUS = {
  in: 3,
  success: 4,
  fail: 5,
  noSubmit: 0,
  beforeUpdate: 6
};
export default {
  name: "multi-upload-photo",
  data() {
    return {
      uploadImgSrc: "",
      aggre: false,
      tempField: [], //当前处理的图片组--上传用,
      uploadStart: 0,
      originSize: 0,
      compressedSize: 0
    };
  },
  computed: {
    ...mapState(["_ticket", "_uuid"]),
    photo_config() {
      return this.pic_desc[this.date_config.pic_desc] || {};
    },
    valid() {
      return this.pic_field.every(x => {
        if (this.declare.desc_title) {
          if (!this.aggre) {
            return false;
          } else if (!this.date.value) {
            return false;
          } else if (this.date_config.pic_desc == "") {
            return true;
          }
          return x.value.length >= x.min_pic_num;
        } else {
          if (!this.date.value) {
            return false;
          } else if (this.date_config.pic_desc == "") {
            return true;
          } else if (this.date_config.is_not_need_upload) {
            return true;
          }
          return x.value.length >= x.min_pic_num;
        }
      });
    },
    AUDIT_STATUS() {
      return AUDIT_STATUS;
    },
    deviceInfo() {
      return {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
      };
    },
    //传递过来整个对象
    formItem() {
      let c = this.$route.params.configs;
      return c || {};
    },
    date() {
      return this.formItem.date || {};
    },
    declare() {
      return this.formItem.declare || {};
    },
    pic_field() {
      return this.formItem.pic_field || [];
    },
    pic_desc() {
      return this.date.pic_desc || {};
    },
    arr() {
      return this.date.options || [];
    },
    date_config() {
      if (this.date.value) {
        return this.arr.filter(x => x.value == this.date.value)[0];
      }
      return {};
    },
    upload_exam_pic_url() {
      return (this.date_config.exam_pic_url || [])[0];
    },
    field_status() {
      return this.formItem.field_status || 0;
    },
    //上传成功态，隐藏底部按钮
    hideBottom() {
      return this.field_status == AUDIT_STATUS.success;
    },
    inApp() {
      return !!Fusion.pickImage;
    },
    hasChooseImage() {
      return !!Fusion.chooseImage;
    },
    country() {
      let up = new URLSearchParams(location.search)
      return up.get('location_country')
    },
    document_enum() {
      return this.formItem.document_enum || "";
    }
  },

  beforeCreate() {
    //一旦进入上传页，返回按钮就正常返回
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 2
      });
  },
  mounted() {
    this.initOutUpload();
  },
  methods: {
    showPicker() {
      if (!this.picker) {
        //处理当前选择项，初始化
        let curIdx = this.arr.findIndex(x => x.value == this.date.value);
        this.picker = this.$createPicker({
          data: [this.arr],
          selectedIndex: curIdx == -1 ? [] : [curIdx],
          cancelTxt: this.$t("取消"),
          confirmTxt: this.$t("确认"),
          onSelect: this.setYear
        });
      }
      this.picker.show();
    },
    setYear(v) {
      this.date.value = v[0];
      this.$emit("btn-update");
    },
    initOutUpload() {
      //端外使用input上传
      if (!this.inApp) {
        const photoBtn = document.getElementsByClassName("input_photo");
        for (let d of photoBtn) {
          imgCompress(d, this.handleAfterChoose, this.handleImageError);
        }
      }
    },
    declareClick() {
      this.aggre = !this.aggre;
      this.$emit("btn-update");
    },
    //采用澳洲方案，先传图片，再提审
    uploadImg() {
      this.uploadStart = +new Date();
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let success = data => {
        this.toast.hide();
        if (data.low_quality_res && data.low_quality_res === 1) {
          showAlertDialog(this, data.low_quality_des);
          return false;
        }
        this.tempField.value.push(data.img_id);
        this.tempField.show_value.push(this.uploadImgSrc);
        this.$emit("btn-update");
        Omega.trackEvent("upload_success", "", {
          duid: this._uuid,
          app_upload: this.inApp,
          wait_time: new Date() - this.uploadStart,
          origin_size: this.originSize,
          compressed_size: this.compressedSize
        });
      };
      up.append("__x_img", this.uploadImgSrc);
      up.append("type", this.tempField.key);
      up.append("document_enum", this.document_enum);

      post(process.env.UPLOAD_IMG, up)
        .then(success)
        .catch(this.httpError);
    },
    submitImg() {
      if (!this.valid) {
        return;
      }
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      this.pic_field.forEach(x => {
        up.append(x.key, JSON.stringify(x.value));
      });
      up.append(this.date.key, this.date.value);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      // @20190213 支持任务中心,type|uid
      if (this.formItem.job_type) {
        up.append("job_type", this.formItem.job_type);
      }
      if (this.formItem.job_uid) {
        up.append("job_uid", this.formItem.job_uid);
      }
      let success = data => {
        this.toast.hide();
        this.$router.replace({ name: "home" });
      };
      post(process.env.ADD_AUDI_INFO, up)
        .then(success)
        .catch(err => {
          this.httpError(err);
          try {
            Omega.trackEvent("ibt_register_submit_review_error_ck", '', {
              path_url: process.env.ADD_AUDI_INFO,  //接口url
              message: JSON.stringify(err),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: err.errno,  //报错码
            });
          } catch (e) {}
        });
    },
    selectImg(p, idx) {
      this.tempField = p;
      // Fusion.chooseImage(
      //   {
      //     source: 3,
      //     quailty: 100,
      //     editable: false,
      //     width: this.deviceInfo.width * 2,
      //     height: this.deviceInfo.height * 2
      //   },
      //   ret => this.handleAfterChoose(ret)
      // );
      // Fusion.pickImage(
      //   {
      //     width: "1500",
      //     height: "1500"
      //   },
      //   ret => this.handleAfterChoose(ret)
      // );
      if (this.hasChooseImage) {
        Fusion.chooseImage(
          {
            source: this.formItem.limit_status ? 2 : 3,
            quailty: 100,
            width: 1500,
            height: 1500,
          },
          (ret) => this.handleAfterChoose(ret)
        );
      } else {
         Fusion.pickImage(
          {
            width: "1500",
            height: "1500",
            source: this.formItem.limit_status ? 2 : 3,
          },
          ret => this.handleAfterChoose(ret)
        );
      }
    },
    handleAfterChoose(ret) {
      let imgSrc
      if (this.inApp && this.hasChooseImage) {
        if (!ret) {
          return;
        }
        imgSrc = "data:image/jpeg" + ";base64," + ret.image;
      } else {
        if (ret.errorCode != 104) {
          return
        }
        imgSrc = ret.imageBase64String;
        if (this.inApp) {
          imgSrc = "data:image/jpeg" + ";base64," + ret.imageBase64String;
        }
      }
      //埋点用
      this.compressedSize = imgSrc.length;
      this.originSize = ret.originSize || 0;
      this.uploadImgSrc = imgSrc;
      this.uploadImg();
    },
    handleImageError() {
      showAlertDialog(this, this.$t("图片尺寸过大"));
    },
    httpError(res) {
      try {
        Omega.trackEvent("upload_fail", "", {
          duid: this._uuid,
          app_upload: this.inApp,
          wait_time: new Date() - this.uploadStart,
          origin_size: this.originSize,
          compressed_size: this.compressedSize,
          msg: res.errmsg || res.message
        });
      } catch (e) {}
      this.toast.hide();
      showAlertDialog(this, this.$t("ERROR_DEFAULT_TEXT"));
    },
    //移除图片
    removeImg(item, idx) {
      item.value.splice(idx, 1);
      item.show_value.splice(idx, 1);
      this.$emit("btn-update");
    },
    outFileChoose(p, idx) {
      this.tempField = p;
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-img {
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 2.5rem;
  .upload-img-content {
    text-align: center;
    padding: 0.3rem 0.32rem 0;
    .content-title {
      font-size: 0.4rem;
      color: #1f2933;
      margin: 0.24rem 0;
    }
    .content-subtitle {
      font-size: 0.3rem;
      color: #1f2933;
      text-align: left;
      margin-bottom: 0.1rem;
    }
    .content-p {
      text-align: left;
      font-size: 0.28rem;
      color: #949494;
      margin-bottom: 0.2rem;
      word-break: break-word;
    }
  }
  .photos {
    padding: 0.3rem 0.32rem 0;
    text-align: left;
    font-size: 0.3rem;
    color: #949494;
    .img-wraper {
      display: flex;
      flex-wrap: wrap;
      & > div {
        width: 3.12rem;
        height: 3.12rem;
        margin: 0.2rem 0.26rem 0.2rem 0;
      }
      .upload-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -0.4rem 0 0 -0.4rem;
        width: 0.8rem;
        height: 0.8rem;
      }

      img {
        width: 100%;
        height: 100%;
      }
      .imgs {
        position: relative;
        .close {
          position: absolute;
          right: -0.15rem;
          top: -0.18rem;
          color: #fff;
          background: #afb0b3;
          width: 0.46rem;
          height: 0.46rem;
          text-align: center;
          line-height: 0.4rem;
          border-radius: 50%;
        }
      }
      .add-pic {
        position: relative;
        font-size: 1rem;
        line-height: 3rem;
        color: #d8d8d8;
        text-align: center;
        background: #fff;
        input {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
        }
      }
    }
  }
  .upload-input-wrapper {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    background: #f5f5f7;
    .declare {
      padding: 0.3rem 0.32rem 0;
      font-weight: bold;
      font-size: 0.28rem;
      color: #949494;
      i {
        display: inline-block;
        vertical-align: middle;
        width: 0.28rem;
        height: 0.28rem;
        background-size: 0.28rem;
        background-image: url(../../images/icon-unchecked@3x.png);
      }
      .active {
        background-image: url(../../images/icon-checked@3x.png);
      }
    }
    .multi-link-upload {
      position: relative;
      margin: 0.4rem auto;
      &.multi-link-upload-active.BR-multi-link-upload {
        color: #000;
        background: #ffe600;
      }
    }
  }
  .select-wraper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 0 0.36rem 0 0.4rem;
    margin-bottom: 0.1rem;
    font-size: 0.36rem;
    color: #414141;
    background: #fff;
  }
  .select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 1.4rem;
    p {
      color: #323233;
    }
  }
  .status-tip {
    width: 7.1rem; //铺满右侧
    margin-right: 0;
    color: #50c636;
    &::before {
      width: 0;
      margin: 0;
    }
  }
  .need_upload {
    // color: #ff4242;
    &::before {
      width: 0;
      margin: 0;
    }
  }
}
</style>
